export default __webpack_public_path__ + "static/media/locker-logo-naut.067ae2f9.png";